import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import SEO from '../components/SEO';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import WhyChooseUs from '../components/WhyChooseUs';
import AboutSection from '../components/AboutSection';
import ClientLogos from '../components/ClientLogos';
import WhatWeDo from '../components/WhatWeDo';
import GoogleReviews from '../components/GoogleReviews';
import InstagramWall from '../components/InstagramWall';
import IndustriesMarquee from '../components/IndustriesMarquee';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';

gsap.registerPlugin(ScrollTrigger);

const HomePage = () => {
  useEffect(() => {
    // Progressive glow effect on scroll
    const ctx = gsap.context(() => {
      ScrollTrigger.create({
        trigger: 'body',
        start: 'top top',
        end: 'bottom bottom',
        onUpdate: (self) => {
          const progress = self.progress;
          document.documentElement.style.setProperty(
            '--glow-intensity',
            `${progress * 100}%`
          );
        },
      });
    });

    return () => ctx.revert();
  }, []);

  return (
    <div className="min-h-screen bg-white text-securelec-dark">
      <SEO 
        title="Electrician Carrum & Bayside Melbourne | Securelec — Electrical, Security & CCTV"
        description="Securelec is your trusted local electrician in Carrum and Bayside Melbourne. We provide general electrical, alarm and security systems, CCTV, access control, and data cabling services for homes and businesses."
        keywords="electrician Carrum, electrician Bayside Melbourne, security systems Carrum, CCTV installation Melbourne, alarm systems Bayside, access control Melbourne, data cabling, EV charger installation, switchboard upgrades"
        canonical="https://securelec.net.au/"
        rawTitle
      />
      <Header />
      <main>
        <HeroSection />
        <WhyChooseUs variant="homepage" />
        <AboutSection />
        <ClientLogos />
        <WhatWeDo />
        <GoogleReviews />
        <InstagramWall />
        <IndustriesMarquee />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
